import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Site } from '../../../models/site';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-dropdown-sites',
    imports: [CommonModule, TranslateModule],
    templateUrl: './dropdown-sites.component.html',
    styleUrl: './dropdown-sites.component.scss'
})
export class DropdownSitesComponent implements OnInit {
  @ViewChild('inputRef', { static: true }) inputRef!: ElementRef<HTMLInputElement>;

  
  @Input() listeSites: Site[] = []; // Replace `any` with the actual type if known
  @Input() currentSite?: Site | undefined;;
  @Output() siteSelected = new EventEmitter<Site>();

  protected listeSites_filtred:Site[] = []; 
  protected toggleSelect:boolean = false;
  protected selectedSite: Site|undefined;
  constructor(private elementRef: ElementRef) {}
  ngOnInit(): void {
  this.listeSites_filtred = [...this.listeSites];
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.toggleSelect = false;
    }
  }

  protected filterSearchSites(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    this.listeSites_filtred = [];
    this.listeSites_filtred = this.filterItems(this.listeSites, value);
  }

  protected definirSiteEnCours(site: Site, event:any) {
    this.siteSelected.emit(site); // Emit selected site
    event.stopPropagation(); 
    this.selectedSite = site;
    this.toggleSelect = false;

  }

  protected openOrClose(){
    this.toggleSelect = !this.toggleSelect;
  }

  protected filterItems(items: any[], value: string): any[] {
    const sites = [...items];
    return sites.filter((x) => {
      const nomMatch = x.nom.toLowerCase().includes(value.toLowerCase());
      return nomMatch;
    });
  }
}
